import { render, staticRenderFns } from "./ExportTab.vue?vue&type=template&id=0463a584&"
import script from "./ExportTab.vue?vue&type=script&lang=js&"
export * from "./ExportTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports